VjsAdmin.LicenseLoginHistory = (function () {
    const me = {};

    me.$loginhistory_table = $('#loginhistory-table');
    me.platform_id = me.$loginhistory_table.attr('data-platform-id');
    me.license_id = me.$loginhistory_table.attr('data-license-id');
    me.district_joint_guid = me.$loginhistory_table.attr('data-district-joint-guid');

    me.init = function () {
        me.initTable();
    };

    me.initTable = function () {
        me.$loginhistory_table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#loginhistory-table',
            formatNoMatches() {
                return 'No login history in this License!';
            },
            showColumns: true,
            buttonsAlign: 'right',
            idField: 'user_id',
            toolbar: '#report-toolbar',
            sortName: 'date_login',
            clickToSelect: true,
            url: Slim.Router.pathFor('platforms.districts.licenses.loginhistory.list.json', {
                platform_id: me.platform_id,
                license_id: me.license_id,
                district_joint_guid: me.district_joint_guid,
            }),
            columns: [
                {
                    title: 'User ID',
                    field: 'user_id',
                    align: 'left',
                    valign: 'middle',
                    visible: true,
                    sortable: true,
                    formatter(value, row) {
                        const url = Slim.Router.pathFor('platforms.districts.licenses.users.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                            user_id: row.user_id,
                        });
                        return `<a href='${url}' target='_blank'>${value}</a>`;
                    },
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        const url = Slim.Router.pathFor('platforms.districts.licenses.users.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                            user_id: row.user_id,
                        });
                        return `<a href='${url}' target='_blank'>${value}</a>`;
                    },
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        const url = Slim.Router.pathFor('platforms.districts.licenses.users.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                            user_id: row.user_id,
                        });
                        return `<a href='${url}' target='_blank'>${value}</a>`;
                    },
                },
                {
                    title: 'Username',
                    field: 'username',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        const url = Slim.Router.pathFor('platforms.districts.licenses.users.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                            user_id: row.user_id,
                        });
                        return `<a href='${url}' target='_blank'>${value}</a>`;
                    },
                },
                {
                    title: 'License',
                    field: 'license_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        const url = Slim.Router.pathFor('platforms.districts.licenses.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                        });
                        return `<a href='${url}' target='_blank'>${value}</a>`;
                    },
                },
                {
                    title: 'Login',
                    field: 'date_login',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Logout',
                    field: 'date_logout',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    visible: false,
                },
                {
                    title: 'Role',
                    field: 'role',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Time Spent (mins)',
                    field: 'time_spent',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the groups timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    row.is_active = row.active;

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (+row.shared === 1) {
                        row.shared = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    } else {
                        row.shared = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    }
                });
                return formattedResult;
            },
        });
    };

    return {
        init: me.init,
    };
}());
